
import { SubDomain } from "../SubDomain.js";
import Timesheet from "./Timesheet.js";
import TimesheetEntriesDomain from "./TimesheetEntriesDomain.js";

export default class TimesheetsDomain extends SubDomain {
  
  constructor(domain, storage, entryStorage) {
    super(domain, Timesheet.MODEL_NAME);
    this._storage = storage;
    this._entryStorage = entryStorage;
  }
  
  list() {
    return this._storage.list;
  }
  
  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        return new Timesheet(this.domain, item);
      }
    }

    return new Timesheet(this.domain, {});
  }
  
  entries() {
    return new TimesheetEntriesDomain(this.domain, this._entryStorage);
  }
}